import { render, staticRenderFns } from "./WarehouseItems.vue?vue&type=template&id=fe4963e4&scoped=true"
import script from "./WarehouseItems.vue?vue&type=script&lang=js"
export * from "./WarehouseItems.vue?vue&type=script&lang=js"
import style0 from "./WarehouseItems.vue?vue&type=style&index=0&id=fe4963e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4963e4",
  null
  
)

export default component.exports